{#if title || description}
  <div class="columns">
    <div class="column">
      <div class="mt-5 mb-5 has-text-centered">
        {#if title}
          <div data-testid="headline">
            {@html title}
          </div>
        {/if}
        {#if description}
          <h2 class="is-size-4 has-text-centered" data-testid="subline">
            {@html description}
          </h2>
        {/if}
      </div>
    </div>
  </div>
{/if}

<script>
import { currentContent, club } from "./stores";

let clubData, title, description;
club.subscribe((c) => (clubData = c));

const transformTitle = (str) => {
  if (!clubData) {
    return;
  }
  str = str.replace("#GOLFCLUB#", clubData.clubname);
  const parts = str.split("-");
  let headline = `<h1 class="is-size-2 has-text-centered">${parts[0]}`;
  if (parts[1]) {
    headline += `<span class="is-size-3">&ndash; ${parts[1]}</span>`;
  }
  headline += "</h1>";
  return headline;
};

currentContent.subscribe((cc) => {
  description = cc?.description ? cc.description : false;
  title = cc?.title ? transformTitle(cc.title) : false;
});
</script>
